import { i18n } from "@goodboydigital/astro";

export class StrUtils
{
    /** Utility for random nickname generation */
    public static randomNickname(): string
    {
        return this.randomChar() + this.randomChar() + this.randomChar();
    }

    /** Get random A-Z character */
    public static randomChar(): string
    {
        return String.fromCharCode(65 + Math.floor(Math.random() * 25));
    }

    /** Get formated position. Ex: 2/6 */
    public static formatPosition(position: number, total = 0): string
    {
        return total ? `${position}/${total}` : String(position);
    }

    /** Format miliseconds to 0'00''0 */
    public static formatRaceTime(time: number): string
    {
        const m = Math.floor((time / 1000 / 60) << 0).toString();
        const s = String(Math.floor((time / 1000) % 60)).padStart(2, '0');
        const ms = Math.floor(time % 1000 / 100).toString();
        
        let message = i18n.translate("raceTime");
        message = message.replace('{m}', m);
        message = message.replace('{s}', s);
        message = message.replace('{ms}', ms);
        
        return message;
    }

    /** Format miliseconds to 00:00:00 */
    public static formatTime(ms: number): string
    {
        const seconds = Math.floor((ms / 1000) % 60);
        const minutes = Math.floor((ms / (1000 * 60)) % 60);
        const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
        const h = (hours < 10) ? `0${hours}` : hours.toString();
        const m = (minutes < 10) ? `0${minutes}` : minutes.toString();
        const s = (seconds < 10) ? `0${seconds}` : seconds.toString();
        
        let message = i18n.translate("time");
        message = message.replace('{h}', h);
        message = message.replace('{m}', m);
        message = message.replace('{s}', s);
        return message;
    }

    /** Format 0-1 to 99% */
    public static formatPercentage(ratio: number): string
    {
        return `${Math.round(ratio * 100)}%`;
    }

    /** Make first letter uppercase */
    public static capitaliseFirstLetter(str: string): string
    {
        return str.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
    }

    /** Get a windlcard regexp by replacing `*` by `(.*?)` */
    public static wildcard(str: string): RegExp
    {
        const raw = this.replaceAll(str, '*', '(.*?)');

        return new RegExp(raw, 'g');
    }

    /** Replace all occurences in a string */
    public static replaceAll(str: string, from: string, to = ''): string
    {
        return str.split(from).join(to);
    }
}
